/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Payment_Timeout_TitleInputs */

const en_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment Incomplete`)
};

const ar_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدفع غير مكتمل`)
};

const de_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung unvollständig`)
};

const es_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago incompleto`)
};

const fr_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement incomplet`)
};

const it_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento incompleto`)
};

const ja_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払いが完了していません`)
};

const ko_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제가 완료되지 않음`)
};

const pt_br_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento não concluído`)
};

const ru_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платеж не завершен`)
};

const th_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การชำระเงินไม่เสร็จสมบูรณ์`)
};

const tr_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme Tamamlanmadı`)
};

const zh_cn_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款未完成`)
};

const zh_tw_dialog_payment_timeout_title = /** @type {(inputs: Dialog_Payment_Timeout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款未完成`)
};

/**
* | output |
* | --- |
* | "Payment Incomplete" |
*
* @param {Dialog_Payment_Timeout_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_payment_timeout_title = /** @type {((inputs?: Dialog_Payment_Timeout_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Payment_Timeout_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_payment_timeout_title(inputs)
	if (locale === "ar") return ar_dialog_payment_timeout_title(inputs)
	if (locale === "de") return de_dialog_payment_timeout_title(inputs)
	if (locale === "es") return es_dialog_payment_timeout_title(inputs)
	if (locale === "fr") return fr_dialog_payment_timeout_title(inputs)
	if (locale === "it") return it_dialog_payment_timeout_title(inputs)
	if (locale === "ja") return ja_dialog_payment_timeout_title(inputs)
	if (locale === "ko") return ko_dialog_payment_timeout_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_payment_timeout_title(inputs)
	if (locale === "ru") return ru_dialog_payment_timeout_title(inputs)
	if (locale === "th") return th_dialog_payment_timeout_title(inputs)
	if (locale === "tr") return tr_dialog_payment_timeout_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_payment_timeout_title(inputs)
	return zh_tw_dialog_payment_timeout_title(inputs)
});